'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

import { sendGTMEventEcommerce } from '../lib/events';
import { GTMEcommerceItem } from '../lib/types';

interface GTMPageViewProps {
  event: 'detail' | 'view_cart' | 'begin_checkout';
  value?: string;
  coupon?: string;
  items: GTMEcommerceItem[];
}

export function GTMPageView({ event, coupon, items }: GTMPageViewProps) {
  const pathname = usePathname();

  useEffect(() => {
    const t = setTimeout(() => {
      sendGTMEventEcommerce({
        event,
        ecommerce: {
          coupon,
          products: items
        }
      });
    }, 0);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return null;
}
